import { useEffect, useState, useRef } from 'react';
import { useNavigate, Link, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import sharedStyles from 'styles/css/SharedStyles.module.scss';
import styles from 'styles/css/Main.module.scss';
import ruleStyles from 'styles/css/RuleStyles.module.scss';
import actionStyles from 'styles/css/ActionStyles.module.scss';
import Logo from 'styles/images/logo/logo512.png';
import Instagram from 'styles/images/svg/instagram.svg';
import LinkedIn from 'styles/images/svg/linkedin.svg';
import YouTube from 'styles/images/svg/youtube.svg';
import Facebook from 'styles/images/svg/facebook.svg';
import ForwardIcon from 'styles/images/svg/forward-white.svg';
import ArrowUp from 'styles/images/svg/arrow-up.svg';
import ArrowDown from 'styles/images/svg/arrow-down.svg';
import { API_CONTACT_US } from 'apis';
import apiRequest from 'utils/apiRequest';
import { handleChangeDataPageAboutUs } from 'reduxx/actions/pages/aboutUs';
import BackIcon from 'styles/images/svg/back.svg';
import shortHeaderStyles from 'styles/css/ShortHeaderStyles.module.scss';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import Swal from 'sweetalert2';
import { useTranslation } from "react-i18next";
import { useLocalePath } from 'utils/useLocalePath';

const ContactUs = () => {

    const { i18n } = useTranslation();
    const { t } = useTranslation();
    const to = useLocalePath();

    const dispatch = useDispatch();
    const navigate = useNavigate();


    const { image, content } = useSelector(state => state.aboutUs);



    useEffect(() => {
        apiContactUs();
    }, []);

    const apiContactUs = () => {
        apiRequest({
            dispatch,
            endpoint: API_CONTACT_US,
            method: 'post',
            data: {width: window.innerWidth},
            successMessage: null,
            onSuccess: (res) => {
                dispatch(handleChangeDataPageAboutUs('image', res.image));
                dispatch(handleChangeDataPageAboutUs('content', res.content));
            }
        });
    };


    return (
        
        <div className={[sharedStyles.container, sharedStyles['pb-[64px]']].join(' ')} >


            <section className={styles.hero} >
                <div className={[sharedStyles['w-full'], sharedStyles.flex, sharedStyles.itemsCenter, sharedStyles['py-s'], sharedStyles['px-s'], sharedStyles.absolute, sharedStyles['top-0'], sharedStyles['z-2'], sharedStyles['bg-white-[0.2]']].join(' ')}>
                    <img onClick={() => navigate(-1)} className={shortHeaderStyles['back-btn']} src={BackIcon} width={18} height={18}  />
                </div>
                <Swiper
                    dir={i18n.dir()}
                    modules={[Pagination, Autoplay]}
                    spaceBetween={0}
                    slidesPerView={1}
                    // pagination={{ clickable: true }}
                    // navigation={true}
                    pagination={false}
                    autoplay={{ delay: 5000, disableOnInteraction: false }}
                    className={styles.swiper}
                >
                    <SwiperSlide >
                        <div className={styles.slide} style={{ backgroundImage: `url(${image})` }}></div>
                    </SwiperSlide>
                </Swiper>

            </section>



            <div className={sharedStyles['container-padding']}>
            <div className={sharedStyles['container-padding']}>
            <div className={sharedStyles['container-padding']}>
                <p className={sharedStyles['text-center']} style={{whiteSpace: "pre-wrap"}}>
                    {content}
                </p>
            </div>
            </div>
            </div>

            
        </div>

    );
}

export default ContactUs;